export default __webpack_public_path__ + "static/media/Cane2Sugar_08.b448644c.png";